/* src/app/shared/authenticated-iframe-wrapper/authenticated-iframe-wrapper.component.css */
.auth-iframe {
  border: none;
  width: 100%;
  background: #f9f9f9;
}
/*# sourceMappingURL=authenticated-iframe-wrapper.component.css.map */
